import { getSanityImgUrl } from "@lib/sanity";
import { toPlainText } from "@portabletext/react";
import { ProductMain, SanityProductPreset } from "@sourceful/shared-types";
import { NextRouter } from "next/router";
import { changeRouteKeepParams } from "../../../lib/changeRouteKeepParams";

export const generateShopStructuredMarkup = (
  preset: SanityProductPreset | null,
  product: ProductMain,
  pricePence: number,
  url: string
) => {
  const description = preset?.description ?? product?.description;

  return {
    "@context": "http://schema.org/",
    "@type": "Product",
    sku: preset?.id ?? product._id,
    name: preset?.name ?? product.name,
    description: description ? toPlainText(description) : "",
    image:
      preset?.images && preset?.images.length > 0
        ? getSanityImgUrl(preset.images[0].asset._ref)
        : product.images && product.images[0]
        ? getSanityImgUrl(product.images[0].asset._ref)
        : "",
    offers: {
      "@type": "Offer",
      url,
      availability: "InStock",
      priceSpecification: {
        "@type": "UnitPriceSpecification",
        price: pricePence / 100,

        referenceQuantity: {
          "@type": "QuantitativeValue",
          value: "1",
          unitCode: "ct",
          valueReference: {
            "@type": "QuantitativeValue",
            value: "1",
            unitCode: "ct",
          },
        },
      },
    },
  };
};

export const routeToLeadGen = (router: NextRouter, productSlug: string) => {
  const baseRoute = router.pathname.replace("[productMain]", productSlug);

  const url = changeRouteKeepParams(router.asPath, `${baseRoute}/lead-gen`);

  router.push(url);
};

export const routeToLeadGenUrl = (router: NextRouter, productSlug: string) => {
  const baseRoute = router.pathname.replace("[productMain]", productSlug);

  return changeRouteKeepParams(router.asPath, `${baseRoute}/lead-gen`);
};
